import { useEffect, useState } from 'react';

// Exclusão mútua em memória, somente entre os dois componentes de avisos públicos.
// Não altera Supabase, cadastro ou autenticação.
type NotificationOwner = 'social' | 'live';
let currentOwner: NotificationOwner | null = null;

export function reserveNotification(owner: NotificationOwner): boolean {
  if (currentOwner !== null && currentOwner !== owner) return false;
  currentOwner = owner;
  return true;
}

export function releaseNotification(owner: NotificationOwner): void {
  if (currentOwner === owner) currentOwner = null;
}


/**
 * Os componentes públicos respeitam o chat existente sem modificar o ChatAssistant.
 * O ChatAssistant atual usa aria-label="Fechar chat" na janela aberta.
 */
export function useChatIsOpen(): boolean {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const check = () => {
      const open = Boolean(document.querySelector('button[aria-label="Fechar chat"]'));
      setIsOpen((previous) => previous === open ? previous : open);
    };
    check();
    const observer = new MutationObserver(check);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);
  return isOpen;
}
